import { useEffect, useRef } from "react";

const SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY;
const SCRIPT_SRC = "https://challenges.cloudflare.com/turnstile/v0/api.js";

export const TurnstileWidget = ({ onToken }) => {
  const containerRef = useRef(null);
  const widgetId = useRef(null);

  useEffect(() => {
    const render = () => {
      if (!containerRef.current || !window.turnstile || widgetId.current !== null) return;
      widgetId.current = window.turnstile.render(containerRef.current, {
        sitekey: SITE_KEY,
        action: "scan",
        "refresh-expired": "auto",
        callback: (token) => onToken(token),
        "expired-callback": () => onToken(""),
        "error-callback": () => onToken(""),
        "timeout-callback": () => onToken(""),
      });
    };
    const existing = document.querySelector(`script[src^="${SCRIPT_SRC}"]`);
    if (window.turnstile) {
      render();
    } else if (existing) {
      existing.addEventListener("load", render, { once: true });
    } else {
      const s = document.createElement("script");
      s.src = `${SCRIPT_SRC}?render=explicit`;
      s.async = true;
      s.defer = true;
      s.addEventListener("load", render, { once: true });
      document.head.appendChild(s);
    }
    return () => {
      if (widgetId.current !== null && window.turnstile?.remove) {
        window.turnstile.remove(widgetId.current);
        widgetId.current = null;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div ref={containerRef} data-testid="turnstile-widget" />;
};
